module.exports = __webpack_public_path__ + "static/img/home_foto3.12666c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_foto3.png
// module id = 82
// module chunks = 0